module.exports = __webpack_public_path__ + "img/lora.a009c8d8.png";